const NODE = {
    // 
    LAUNCH: {
        name: 'launch',
        label: '',
        value: ''
    },
    // 流程结束
    End: {
        name: 'end',
        label: '流程结束',
        value: '0'
    },
}

/**
 * 获取所有name数组
 * @returns 包含所有name数组
 */
const getNameArray = () => {
    let arr = []
    for (let key in NODE) {
        arr.push(NODE[key].name)
    }
    return arr;
}

export default Object.freeze(NODE)

/**
 * 通过value获取name
 * @param {String} value
 * @returns 
 */
export const getNameByValue = value => {
    for (let key in NODE) {
        let node = NODE[key]
        if (node.value === value) {
            return node.name
        }
    }
}

/**
 * 通过name获取value
 * @param {String} name
 * @returns 
 */
export const getValueByName = name => {
    for (let key in NODE) {
        if (NODE[key].name === name) {
            return NODE[key].value
        }
    }
}

export const nameArray = getNameArray()